<template>
  <v-app :dark="dark">
    <l-nav-drawer
      :clipped="$L.cfg.clipped"
      :items="navDrawerItems"
      :permission="permission"
      v-if="!closeMainDrawer"
    >
      <template slot="prepend" slot-scope="{mini}">
        <slot :mini="mini" name="logo">
          <v-layout align-center class="headline" style="height: 96px">
            <span class="primary--text pl-3">{{$L.cfg.appName.full}}</span>
            <span class="px-2 font-weight-light white--text" v-if="$L.cfg.appName.subTitle">|</span>
            <span class="font-weight-light white--text">{{$L.cfg.appName.subTitle}}</span>
          </v-layout>
          <v-divider></v-divider>
        </slot>
      </template>
    </l-nav-drawer>
    <l-toolbar>
      <slot name="toolbar-title" slot="toolbar-title">
        <v-toolbar-title class="font-weight-regular">{{$L.cfg.appName.full}}</v-toolbar-title>
      </slot>
      <slot name="toolbar-items" slot="toolbar-items"></slot>
    </l-toolbar>
    <l-content></l-content>
    <slot name="footer" v-if="$route.meta.showFooter"></slot>
  </v-app>
</template>

<script>
import {createHelpers} from 'vuex-map-fields'
import LNavDrawer from './LNavDrawer'
import {navDrawerItems} from '@/router/navDrawerItems'
import LToolbar from './LToolbar'
import LContent from './LContent/LContent'
const {mapFields} = createHelpers({
  getterType: '$L/getField',
  mutationType: '$L/updateField',
})

// import route from '../../router/routes'

export default {
  name: 'LMain',
  components: {
    LContent,
    LNavDrawer,
    LToolbar,
  },
  data: () => ({
    navDrawerItems: navDrawerItems
  }),
  computed: {
    ...mapFields([
      'dark',
    ]),
    permission () {
      return this.$store.state.login.permission
    },
    closeMainDrawer () {
      let route = this.$route
      let c = route.matched[0] && route.matched[0].components
      return !(c && c.default && c.default.name === this.$L.opts.MAIN_COMPONENT_NAME)
    }
  },
  beforeDestroy () {
    console.log('destroy LMain')
  }
}
</script>
